import { Icon } from './Icon';
import { useSidebarCollapse } from './sidebar-collapse';

/**
 * The top-bar control that collapses/expands the navigation sidebar (F-043).
 * A native button (keyboard-operable) bound to the shared collapse context;
 * exposes its state to assistive technology via `aria-expanded` and a dynamic
 * accessible name describing the action it will perform (FR-007).
 */
export function SidebarToggle() {
  const { collapsed, toggle } = useSidebarCollapse();
  return (
    <button
      type="button"
      onClick={toggle}
      aria-expanded={!collapsed}
      aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      className="inline-flex h-5 w-5 cursor-pointer items-center justify-center border-0 bg-transparent p-0 text-text-secondary hover:text-text-primary"
    >
      <Icon name={collapsed ? 'chevronRight' : 'chevronLeft'} size={16} />
    </button>
  );
}
